import React, { useCallback, useContext, useState } from 'react'
import { apiContext } from 'services/ApiContext'
import { Checkbox, Modal } from 'antd'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import { AGB_NEEDS_AGREEMENT } from 'utils/constants'
import { useMutation } from '@apollo/client'
import { SAVE_USER } from 'graphql/queries/userEntities/userQueries'

import './style.scss'
import { userToInput } from 'graphql/util/inputFunctions'

const AGBNotifier = () => {
  const { user, userId } = useContext(apiContext)
  const [userOptedOut, setUserOptedOut] = useState(user.agreedLatestAGB || !AGB_NEEDS_AGREEMENT)
  const [checkedAGB, setCheckedAGB] = useState(false)
  const [saveUser] = useMutation(SAVE_USER)

  const onOk = useCallback(() => {
    const userInput = userToInput({ ...user, agreedLatestAGB: true })
    const optimisticResponse = {
      saveUser: {
        ...user,
        agreedLatestAGB: true,
      },
    }
    saveUser({ optimisticResponse, variables: { userId, userInput } })
    setUserOptedOut(true)
  }, [])

  return (
    <Modal
      visible={!userOptedOut}
      centered
      onOk={onOk}
      cancelButtonProps={{ disabled: true }}
      okButtonProps={{ disabled: !checkedAGB }}
      title={
        <span className="updated-agb-modal-title">
          <FormattedMessage id="general.updatedAGBTitle" />
        </span>
      }
      destroyOnClose
      maskClosable={false}
      keyboard={false}
      width="650px"
    >
      <div className="updated-agb-modal">
        <FormattedMessage id="general.updatedAGB" />
        <div className="agb-confirm">
          <Checkbox checked={checkedAGB} onChange={(e) => setCheckedAGB(e.target.checked)} />{' '}
          <FormattedHTMLMessage id="general.checkAGB" />
        </div>
      </div>
    </Modal>
  )
}

export default AGBNotifier
